import { ArrayElement } from "@epcnetwork/core-ui-kit";
import { timezones } from "./timezones.constants";

export const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone as ArrayElement<
  typeof timezones
>;

export const appTimezone = "America/New_York";
